import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

import styles from "../styles/footer.module.scss"

const Footer = () => {
  const { fileName, wpgraphql } = useStaticQuery(graphql`
    query FOOTER {
      fileName: file(relativePath: { eq: "white-vast-logo.png" }) {
        childImageSharp {
          fixed(width: 180, webpQuality: 100) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }

      wpgraphql {
        listOne: menus(where: { id: 590 }) {
          nodes {
            menuItems(first: 50, where: { id: 7158 }) {
              nodes {
                id
                label
                childItems {
                  nodes {
                    id
                    label
                    url
                    description
                  }
                }
              }
            }
          }
        }

        listTwo: menus(where: { id: 590 }) {
          nodes {
            menuItems(first: 50, where: { id: 7165 }) {
              nodes {
                id
                label
                childItems {
                  nodes {
                    id
                    label
                    url
                    description
                  }
                }
              }
            }
          }
        }

        listThree: menus(where: { id: 590 }) {
          nodes {
            menuItems(first: 50, where: { id: 7171 }) {
              nodes {
                id
                label
                childItems {
                  nodes {
                    id
                    label
                    url
                    description
                  }
                }
              }
            }
          }
        }

        legalFooter: menus(where: { id: 591 }) {
          nodes {
            menuItems {
              nodes {
                id
                label
                url
              }
            }
          }
        }
      }
    }
  `)

  const listOne = wpgraphql.listOne.nodes[0].menuItems.nodes[0]
  const listTwo = wpgraphql.listTwo.nodes[0].menuItems.nodes[0]
  const listThree = wpgraphql.listThree.nodes[0].menuItems.nodes[0]
  const legalFooter = wpgraphql.legalFooter.nodes[0].menuItems.nodes

  return (
    <div className={styles.footerSection}>
      <div className={styles.container}>
        <div className={styles.mainFooter}>
          {/* SUMMARY */}
          <div className={styles.summary}>
            {/* prettier-ignore */}
            <svg width="165" height="34" xmlns="http://www.w3.org/2000/svg"> <g fill="none" fillRule="evenodd" opacity=".844"><g><path d="M53.732 21.74c0 1.375-.505 2.45-1.515 3.223-1.01.773-2.471 1.16-4.384 1.16-.817 0-1.569-.075-2.257-.226-.687-.128-1.278-.3-1.773-.515-.472-.237-.848-.494-1.128-.774-.258-.3-.387-.602-.387-.902 0-.258.065-.505.194-.742.15-.236.365-.44.644-.612.58.43 1.258.816 2.031 1.16.774.323 1.655.484 2.644.484 2.235 0 3.352-.752 3.352-2.256 0-1.225-.741-2.02-2.224-2.386l-2.676-.709c-1.31-.344-2.267-.838-2.869-1.482-.601-.667-.902-1.515-.902-2.547 0-.558.107-1.096.322-1.611a3.768 3.768 0 011.064-1.354c.473-.387 1.053-.688 1.74-.903.71-.236 1.537-.354 2.483-.354 1.504 0 2.718.225 3.643.677.924.43 1.386.934 1.386 1.515 0 .279-.076.526-.226.74a1.202 1.202 0 01-.548.484c-.387-.257-.935-.537-1.644-.838-.71-.3-1.547-.45-2.514-.45-.968 0-1.741.182-2.321.547-.56.365-.839.881-.839 1.547 0 .494.162.913.484 1.257.322.344.86.602 1.612.774l2.224.548c1.461.365 2.557.913 3.288 1.644.73.709 1.096 1.676 1.096 2.9zm9.002 4.383c-1.504 0-2.729-.333-3.674-1-.925-.665-1.386-1.772-1.386-3.319V6.494a2.93 2.93 0 01.483-.13c.237-.064.484-.096.742-.096.902 0 1.353.387 1.353 1.16v3.707h5.287c.065.108.129.258.194.451.064.172.096.366.096.58 0 .731-.322 1.097-.967 1.097h-4.61v8.38c0 .86.237 1.472.71 1.837.494.344 1.182.516 2.063.516a4.5 4.5 0 001.225-.194c.451-.129.827-.279 1.128-.45.129.128.247.29.355.483.107.193.16.419.16.676 0 .473-.279.86-.838 1.16-.558.302-1.332.452-2.32.452zm6.744-15.246c.107-.043.269-.086.484-.129.236-.064.483-.096.741-.096.903 0 1.354.397 1.354 1.192v8.284c0 1.397.365 2.396 1.096 2.997.73.58 1.74.87 3.03.87.86 0 1.59-.085 2.192-.257.602-.194 1.075-.387 1.418-.58v-12.28a2.96 2.96 0 01.484-.13c.237-.064.473-.096.709-.096.924 0 1.387.397 1.387 1.192v11.217c0 .451-.065.817-.194 1.096-.108.258-.387.516-.838.773-.494.28-1.182.548-2.063.806-.86.258-1.902.387-3.127.387-2.15 0-3.804-.473-4.964-1.418-1.14-.946-1.709-2.428-1.709-4.448v-9.38zm30.457 12.377c0 .43-.097.763-.29 1-.172.236-.451.472-.838.709-.43.28-1.043.537-1.838.773-.795.258-1.708.387-2.74.387-1.16 0-2.224-.15-3.191-.451a6.827 6.827 0 01-2.515-1.386c-.688-.645-1.225-1.45-1.611-2.418-.366-.988-.549-2.17-.549-3.545 0-1.397.194-2.59.581-3.578.386-1.01.903-1.837 1.547-2.482a6.157 6.157 0 012.321-1.418 9.016 9.016 0 012.87-.451c.687 0 1.353.086 1.998.258a7.584 7.584 0 011.676.644V4.818a2.95 2.95 0 01.483-.13c.237-.064.473-.096.71-.096.924 0 1.386.387 1.386 1.16v17.502zm-2.58-9.637c-.429-.3-.923-.559-1.482-.774-.559-.214-1.204-.322-1.934-.322-.666 0-1.3.108-1.902.322a3.772 3.772 0 00-1.547 1c-.451.45-.817 1.053-1.096 1.805-.258.752-.387 1.665-.387 2.74 0 1.976.473 3.405 1.418 4.286.946.881 2.203 1.322 3.772 1.322.752 0 1.364-.075 1.837-.226a6.825 6.825 0 001.322-.612v-9.54zm10.216 12.023c-.108.043-.27.086-.484.129a2.464 2.464 0 01-.708.096c-.925 0-1.387-.387-1.387-1.16V10.877c.107-.043.268-.086.484-.129.237-.064.483-.096.741-.096.902 0 1.354.397 1.354 1.192V25.64zm-2.966-19.533c0-.451.15-.827.451-1.128.323-.322.73-.484 1.225-.484.494 0 .892.162 1.193.484.3.3.451.677.451 1.128 0 .451-.15.838-.45 1.16-.302.301-.7.452-1.194.452s-.902-.15-1.225-.452a1.639 1.639 0 01-.45-1.16zm21.83 12.151c0 1.204-.171 2.289-.515 3.256-.344.967-.839 1.794-1.483 2.482a6.168 6.168 0 01-2.288 1.58c-.903.364-1.913.547-3.03.547-1.118 0-2.128-.183-3.031-.548a6.456 6.456 0 01-2.32-1.58c-.646-.687-1.14-1.514-1.484-2.481-.344-.967-.516-2.052-.516-3.256 0-1.203.172-2.288.516-3.255.365-.967.87-1.794 1.515-2.482a6.466 6.466 0 012.32-1.58c.903-.364 1.903-.547 3-.547 1.096 0 2.094.183 2.997.548a6.155 6.155 0 012.29 1.58c.644.687 1.138 1.514 1.481 2.481.366.967.548 2.052.548 3.255zm-7.317-5.737c-1.46 0-2.61.505-3.45 1.515-.838 1.01-1.256 2.417-1.256 4.222 0 1.827.408 3.245 1.224 4.255.839.989 2 1.483 3.482 1.483 1.483 0 2.633-.505 3.449-1.515.817-1.01 1.225-2.418 1.225-4.223 0-1.805-.42-3.212-1.257-4.222-.817-1.01-1.955-1.515-3.417-1.515zm17.947-2.127c.988 0 1.913.161 2.773.483a5.97 5.97 0 012.224 1.45c.644.645 1.14 1.462 1.483 2.45.365.989.548 2.15.548 3.481 0 1.354-.183 2.525-.548 3.514-.366.988-.881 1.805-1.548 2.45-.645.644-1.429 1.128-2.353 1.45-.924.3-1.934.451-3.03.451-1.054 0-2.01-.129-2.87-.387-.837-.236-1.525-.515-2.062-.838-.452-.28-.763-.548-.936-.806-.171-.279-.257-.644-.257-1.095V4.817a2.92 2.92 0 01.484-.128c.235-.065.483-.097.74-.097.903 0 1.355.387 1.355 1.16v5.77a7.565 7.565 0 011.676-.774c.666-.236 1.44-.354 2.32-.354zm-.386 2.127c-.753 0-1.441.14-2.064.42-.601.257-1.118.569-1.547.934v9.122c.323.236.785.462 1.386.676.623.215 1.343.323 2.16.323.73 0 1.385-.108 1.966-.323a4.07 4.07 0 001.547-1.063c.43-.473.763-1.064 1-1.773.236-.73.354-1.59.354-2.579 0-.988-.118-1.847-.354-2.578-.237-.73-.57-1.322-1-1.773a3.774 3.774 0 00-1.547-1.031 4.994 4.994 0 00-1.901-.355zm14.177 13.119a2.914 2.914 0 01-.483.129 2.454 2.454 0 01-.71.096c-.923 0-1.386-.387-1.386-1.16V10.877c.108-.043.27-.086.484-.129.237-.064.483-.096.741-.096.903 0 1.354.397 1.354 1.192V25.64zm-2.965-19.533c0-.451.15-.827.452-1.128.322-.322.73-.484 1.224-.484s.892.162 1.193.484c.301.3.45.677.45 1.128 0 .451-.149.838-.45 1.16-.3.301-.699.452-1.193.452-.494 0-.902-.15-1.224-.452a1.64 1.64 0 01-.452-1.16zm13.095 20.016c-1.505 0-2.73-.333-3.675-1-.925-.665-1.387-1.772-1.387-3.319V6.494a2.99 2.99 0 01.484-.13c.237-.064.483-.096.741-.096.903 0 1.354.387 1.354 1.16v3.707h5.287c.065.108.129.258.193.451.066.172.097.366.097.58 0 .731-.322 1.097-.967 1.097h-4.61v8.38c0 .86.237 1.472.71 1.837.494.344 1.182.516 2.063.516a4.51 4.51 0 001.225-.194c.451-.129.827-.279 1.128-.45.129.128.247.29.354.483.108.193.161.419.161.676 0 .473-.28.86-.837 1.16-.559.302-1.332.452-2.321.452zM23.463 0H10.201C4.567 0 0 4.567 0 10.2v13.26c0 5.633 4.567 10.2 10.201 10.2h13.262c5.634 0 10.201-4.567 10.201-10.2V10.2c0-5.633-4.567-10.2-10.201-10.2z" fill="#FFF" fillRule="nonzero"/> <path d="M10.425 20.808a4.284 4.284 0 100-8.569 4.284 4.284 0 000 8.569z" fill="#1C1F50" fillRule="nonzero"/> <path d="M22.378 20.298a3.774 3.774 0 100-7.549 3.774 3.774 0 000 7.549z" stroke="#1C1F50" strokeWidth="2"/></g></g></svg>
            <div className={styles.text}>
            Live streaming platform and browser-based creator studio for hosting branded, dynamic live stream events that dazzle and engage audiences.
            </div>
          </div>

          {/* FEATURES */}
          <div className={`${styles.list} ${styles.inactive}`}>
            <div className={styles.header}>{listOne.label.toUpperCase()}</div>
            {listOne.childItems.nodes.map(link =>
              link.label === "external" ? (
                <a key={link.id} href={link.url}>
                  {link.description}
                </a>
              ) : (
                <Link key={link.id} to={link.url}>
                  {link.label}
                </Link>
              )
            )}
          </div>

          {/* RESOURCES */}
          <div className={`${styles.list} ${styles.inactive}`}>
            <div className={styles.header}>{listTwo.label.toUpperCase()}</div>
            {listTwo.childItems.nodes.map(link =>
              link.label === "external" ? (
                <a key={link.id} href={link.url}>
                  {link.description}
                </a>
              ) : (
                <Link key={link.id} to={link.url}>
                  {link.label}
                </Link>
              )
            )}
          </div>

          {/* COMPANY */}
          <div className={styles.list}>
            <div className={styles.header}>{listThree.label.toUpperCase()}</div>
            <a href={process.env.GATSBY_LOGIN_URL}>Sign In</a>
            {listThree.childItems.nodes.map(link =>
              link.label === "external" ? (
                <a key={link.id} href={link.url}>
                  {link.description.split("[br]")[0]}
                  <br />
                  {link.description.split("[br]")[1]}
                </a>
              ) : (
                <Link key={link.id} to={link.url}>
                  {link.label}
                </Link>
              )
            )}
          </div>
        </div>
        <div className={styles.bottomFooter}>
          <div className={styles.left}>
            <div>
              © <Link to="/terms">Vast Communications LLC </Link> {new Date().getFullYear()}
            </div>
            {legalFooter.slice(1).map(link => (
              <div>
                <Link key={link.id} to={link.url}>
                  {link.label}
                </Link>
              </div>
            ))}
          </div>

          <div className={styles.right}>
            <a
              href="https://www.facebook.com/studiobit_io "
              target="_blank"
              rel="noopener"
            >
              <img
                width="33"
                height="33"
                src={"/images/facebook-icon-footer.svg"}
                alt="facebook icon"
              />
            </a>
            <a
              href="https://twitter.com/studiobit_io "
              target="_blank"
              rel="noopener"
            >
              <img
                width="33"
                height="33"
                src={"/images/twitter-icon-footer.svg"}
                alt="twitter icon"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/studiobit_io "
              target="_blank"
              rel="noopener"
            >
              <img
                width="33"
                height="33"
                src={"/images/linkedin-icon-footer.svg"}
                alt="linkedin icon"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
